import { render } from "./Volunteer.vue?vue&type=template&id=15a138c8&scoped=true"
import script from "./Volunteer.vue?vue&type=script&lang=js"
export * from "./Volunteer.vue?vue&type=script&lang=js"

import "./Volunteer.vue?vue&type=style&index=0&id=15a138c8&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a138c8"]])

export default __exports__